import { PracticePathVideoEditorPageComponent } from './practice-path-video-editor-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: "",
    component: PracticePathVideoEditorPageComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PracticePathVideoEditorRoutingModule { }
